import React, { FC, Children } from 'react';
import ctaEnums from '../../../enums/CTA.enums';

const ctaModifierClasses = {
  [ctaEnums.primaryRed]: 'cta-button--red',
  [ctaEnums.primaryWhite]: 'cta-button--white',
  [ctaEnums.primaryBlack]: 'cta-button--black',
  [ctaEnums.secondaryRed]: 'cta-button--sec-red',
  [ctaEnums.secondaryWhite]: 'cta-button--sec-white',
};

const CTAButton: FC<{ type: ctaEnums, children?: any }> = (props) => {
  const child = Children.only(props.children);

  if (React.isValidElement(child)) {
    const childClassName = (child?.props as any)?.className;
    const ctaClassName = `cta cta-button ${ctaModifierClasses?.[props.type] || ''}`;
    const newProps = {
      className: childClassName ? `${ctaClassName} ${childClassName}` : ctaClassName,
    };
    return React.cloneElement(child, { ...newProps });
  }

  return null;
};

export { ctaEnums };
export default CTAButton;
